import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { TextField, Button, CircularProgress, Dialog, DialogActions, DialogTitle, Checkbox } from '@mui/material'
import { setUserInfo, setLogin } from '../../redux/userSlice';
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme)=>({
  row:{
      maxWidth:'400px', 
      margin:'0 auto', 
      padding:'270px 0px 50px 0px',
      
      fontFamily:[
        'Noto Sans KR'
      ],

      [theme.breakpoints.down(1025)]: {
        padding:'150px 0 0px 0',
      }
  },
  loginDiv:{ 
      padding:'30px 0',

      [theme.breakpoints.down(1025)]: {
        padding:' 0px',
      }
  },
  loginH1:{ 
    fontSize:'35px', 
    textAlign:'center', 
    padding:'0 0 40px 0'
  },
  loginForm:{ 
    display:'flex', 
    flexDirection:'column', 
    padding:'0 10px',

  },
  loginFormDiv:{ 
    padding:'10px 0 0 0', 
    textAlign:'center',
  },
  loginFormBox:{
    display:'flex',
    justifyContent:'space-between',
    alignItems: 'center',
    margin:'5px 0',
  },
  idInput:{
    width:'100%',
    padding:'9px 7px',
    height:'50px',
    letterSpacing:'-0.7px',
    fontSize:'13px',
    borderRadius:'3px',
    border:'1px solid #ccc',
    '&::placeholder':{
      color:'#CCCCCC'
    },
    '&:focus-within':{
      outline:'none'
    },

    fontFamily:[
      'Noto Sans KR'
    ]
  },
  passwordInput:{
    width:'100%',
    padding:'9px 7px',
    height:'50px',
    letterSpacing:'-0.7px',
    fontSize:'13px',
    borderRadius:'3px',
    border:'1px solid #ccc',
    '&::placeholder':{
      color:'#CCCCCC'
    },
    '&:focus-within':{
      outline:'none'
    },

    fontFamily:[
      'Noto Sans KR'
    ]
  },
  checkboxLabel:{
    fontSize:'13px', 
    marginRight:'10px', 
  },
  checkbox:{
    '&:hover':{
      backgroundColor: '#F7FBF2'
    }
  },
  checkboxInput:{
    marginRight:'5px',
    
  },
  checkboxBtn:{ 
    border:'none', 
    background:'none', 
    fontSize:'13px', 
    borderRight:'1px solid #232323', 
    color:'#232323',
    paddingRight:'5px',
    fontFamily:[
      'Noto Sans KR'
    ],
    '&:last-child':{ marginRight:'0',  borderRight:'none', paddingLeft:'5px'},
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalBox: {
    width: 500,
    height: 300,
    backgroundColor: '#fff',
    borderRadius: 10,
    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
  },
  bottomLoginBtn: props => ({ 
    width:'100%',
    height:'40px',
    margin:'10px 0 8px 0',
    '&:last-child':{margin:'0'},
    background: props.palette.third.dark,
    color:'#fff',
    borderRadius:'3px',

    fontFamily:[
      'Noto Sans KR'
    ]
    
  }),
  bottomJoinBtn:{ 
    width:'100%',
    height:'40px',
    margin:'10px 0 8px 0',
    '&:last-child':{margin:'0'},
    borderRadius:'3px',
    background:'#fff',
    border:'1px solid #007235',
    color:'#007235',

    fontFamily:[
      'Noto Sans KR'
    ]
  },
  loginButtonDiv:{
    position:'relative'
  },
  loadingIcon:{
    position:'absolute',
    top:'-100px',
    left:'45%',
  },
  modalBoxH1:{
    textAlign:'center',
    fontSize:'25px',
    padding:'15px 0 40px 0',
    fontFamily:[
      'Noto Sans KR'
    ],
  },
  labelBox:{
    padding:'0px 0 20px 0',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    fontFamily:[
      'Noto Sans KR'
    ],
  },
  labelDiv:{
    width:'70px',
    textAlign:'center'
  },
  label:{
    fontSize:'1px',
    padding:'0 10px 0 0',
  },
  btnDiv:{
    textAlign:'center',
    padding:'20px 0 0 0'
  },


}));


const Login = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const dispatch = useDispatch()
  let navigate = useNavigate();
  const login = useSelector(state => state.user.login);
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');

  const [findId, setFindId] = useState('');
  const [findName, setFindName] = useState('');
  const [findEmail, setFindEmail] = useState('');

  const [openId, setOpenId] = useState(false);
  const [openPw, setOpenPw] = useState(false);

  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState('');

  const [autoChecked, setAutoChecked] = useState(true)


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  useEffect(() => {
    if (login) {
      navigate("/");
    }
  } , [login])


  const getLogininform = async() => {
    if(userId === '' || password === '') return;

    setLoading(true)
    let ip = ''
    // try {
    //   const response = await axios.get('https://api.ipify.org?format=json');
    //   ip = response.data.ip;
    // } catch (error) {
    //   console.error(error);
    //   return
    // }

    try {
      const res = await axios.post('/api/user/loginUser/', {mb_id: userId, mb_password: password, mb_ip: ip, auto_login: autoChecked }) 

      if (res.data.success === false && res.data.code === 5) {
        setDialog('존재하지 않는 아이디 입니다.')
        setLoading(false)
        return
      }
      if (res.data.success === false && res.data.code === 6) {
        setDialog('비밀번호가 틀립니다.')
        setLoading(false)
        return
      }
      if (res.data.success === false && res.data.code === 7) {
        setDialog('현재 심사중인 회원 입니다')
        setLoading(false)
        return
      }
      if (res.data.success === false && res.data.code === 8) {
        setDialog('현재 탈퇴한 회원 입니다')
        setLoading(false)
        return
      }
      if (res.data.success === false) {
        setDialog('로그인 실패')
        setLoading(false)
        return
      }
      dispatch(setUserInfo(res.data.result))
      dispatch(setLogin(true))
      navigate("/");

    }catch (e) {
      console.log(e)
    }
    setLoading(false)
  }


  const onLogin = () => {
    if (userId === '') {
      setDialog('아이디를 입력 해주세요.')
      return
    }
    if (password === '') {
      setDialog('비밀번호를 입력 해주세요.')
      return
    }
    
    getLogininform()
    
  }

  const onFindId = async() => {
    if(findName === '' || findEmail === '') return;

    try {
      setLoading(true)
      const res = await axios.post('/api/user/findId/', {mb_name: findName, mb_email: findEmail }) 

      if (res.data.success === false && res.data.code === 2) {
        setLoading(false)
        setDialog('존재하지 않는 이름 입니다.')
        return
      }
      if (res.data.success === false && res.data.code === 3) {
        setLoading(false)
        setDialog('존재하지 않는 이메일 입니다.')
        return
      }
      if (res.data.success === false) {
        setLoading(false)
        setDialog('찾기 실패')
        return
      }

      setFindId(res.data.mbId);

    }catch (e) {
      console.log(e)
    }
    setLoading(false)
  }

  const onFindPw = async() => {
    if(findName === '' || findEmail === '' || findId === '') return;

    try {
      setLoading(true)
      const res = await axios.post('/api/user/findPassword/', {mb_id: findId, mb_name: findName, mb_email: findEmail }) 

      if (res.data.success === false && res.data.code === 2) {
        setLoading(false)
        setDialog('존재하지 않는 이름 입니다.')
        return
      }
      if (res.data.success === false && res.data.code === 3) {
        setLoading(false)
        setDialog('존재하지 않는 이메일 입니다.')
        return
      }
      if (res.data.success === false && res.data.code === 4) {
        setLoading(false)
        setDialog('존재하지 않는 아이디 입니다.')
        return
      }
      if (res.data.success === false) {
        setLoading(false)
        setDialog('찾기 실패')
        return
      }
      
      setDialog(`${findEmail} 로 임시 비밀번호 보냈습니다.`)
      setOpenPw(false)

    }catch (e) {
      console.log(e)
    }
    setLoading(false)
  }

  useEffect(() => {

    return () => {
      setUserId('')
      setPassword('')
      setFindId('')
      setFindName('')
      setFindEmail('')
    }
  }, [])

  return (
    <div>
      <div className={classes.row}>     
        <div className={classes.loginDiv}>
          <h1 className={classes.loginH1}>로그인</h1>
          <div className={classes.loginForm} >
            <div className={classes.loginFormDiv}>
              <input 
                className={classes.idInput} 
                type='text' 
                id="userId" 
                name='userId' 
                value={userId} 
                onChange={(e) => {setUserId(e.target.value)}}
                placeholder='아이디를 입력해주세요'
              />
            </div>
            <div className={classes.loginFormDiv}>
              <input 
                className={classes.passwordInput} 
                type='password' 
                id='password' 
                name='password' 
                value={password} 
                onChange={(e) => {setPassword(e.target.value)}}
                placeholder='비밀번호를 입력해주세요'
                onKeyDown={(e) => {
                  if(e.key === 'Enter') {
                    onLogin()
                  }
                }}
              />
            </div>
            <div className={classes.row2}>
              <div className={classes.loginFormBox}>
                <div className={classes.loginFormBoxLeft}>
                  <Checkbox 
                      checked={autoChecked}
                      onChange={e => setAutoChecked(e.target.checked)}
                  />
                  <label className={classes.checkboxLabel}>
                    자동로그인
                  </label>
                </div>
                <div className={classes.loginFormBoxRight}>
                  <button 
                    className={classes.checkboxBtn}
                    onClick={() => setOpenId(true)}
                  >
                    아이디 찾기
                  </button>

                  <button 
                    className={classes.checkboxBtn}
                    onClick={() => setOpenPw(true)}
                  >
                    비밀번호 찾기
                  </button>

                </div>
              </div>
            </div>
            <div className={classes.loginButtonDiv}>
            
              {loading ? (<CircularProgress className={classes.loadingIcon} />) : 
                (
                <button 
                  className={classes.bottomLoginBtn}
                  onClick={onLogin}
                >
                로그인
                </button>  
                )
              }
                 
              <Link to="/Register">
                <button 
                  className={classes.bottomJoinBtn}
                >
                  회원가입
                </button>
              </Link>
            </div>
          </div>
          </div>
        </div>

        <Modal
          open={openId}
          onClose={() => {
            setFindId('')
            setFindName('')
            setFindEmail('')
            setOpenId(false)
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className={classes.modal}
        >
          <Box className={classes.modalBox}>
            <h1 className={classes.modalBoxH1}>아이디 찾기</h1>
            <div className={classes.labelBox}>
              <div className={classes.labelDiv}>
                <label className={classes.label}>
                  이름
                </label>
              </div>
              <TextField 
                size='small' sx={{"& .MuiInputBase-root": {height: 25}}} 
                hiddenlabel="true" 
                variant="outlined" 
                value={findName}
                onChange={(e) => {setFindName(e.target.value)}}
              />
            </div>
            <div className={classes.labelBox}>
              <div className={classes.labelDiv}>
                <label className={classes.label}>
                  이메일
                </label>
              </div>
              <TextField 
                size='small' sx={{"& .MuiInputBase-root": {height: 25}}} 
                hiddenlabel="true" 
                variant="outlined" 
                value={findEmail}
                onChange={(e) => {setFindEmail(e.target.value)}}
              />
            </div>
            
            {loading ? (
              <div
                style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}
              >
                <CircularProgress />
              </div>
            ) : 
              (
                <div className={classes.btnDiv}>
                  <Button 
                    variant="outlined"
                    onClick={() => {onFindId()}}
                    style={{ 
                      background:'#007235', 
                      color:'#fff',
                      fontFamily:[
                        'Noto Sans KR'
                      ],
                      width:'120px',
                      fontSize:'16px',
                    }}                
                  >
                  확인
                </Button>
                </div>
              )
            }

            {findId !== '' && (<h3>당신의 아이디는 {findId} 입니다.</h3>)}
          </Box>

        </Modal>

        <Modal
          open={openPw}
          onClose={() => {
            setFindId('')
            setFindName('')
            setFindEmail('')
            setOpenPw(false)
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className={classes.modal}
        >
          <Box className={classes.modalBox}>
            <h1 className={classes.modalBoxH1}>비밀번호 찾기</h1>
           <div className={classes.labelBox}>
              <div className={classes.labelDiv}>
                <label className={classes.label}>
                  아이디
                </label>
              </div>
              <TextField 
                size='small' sx={{"& .MuiInputBase-root": {height: 25}}} 
                hiddenlabel="true" 
                variant="outlined" 
                value={findId}
                onChange={(e) => {
                  setFindId(e.target.value)
                }}
              />
           </div>
            <div  className={classes.labelBox}>
              <div className={classes.labelDiv}>
                <label className={classes.label}>
                  이름
                </label>
              </div>
              <TextField 
                size='small' sx={{"& .MuiInputBase-root": {height: 25}}} 
                hiddenlabel="true" 
                variant="outlined" 
                value={findName}
                onChange={(e) => {
                  setFindName(e.target.value)
                }}
              />
            </div>
            <div  className={classes.labelBox}>
              <div className={classes.labelDiv}>
                <label className={classes.label}>
                  이메일
                </label>
              </div>
              <TextField 
                size='small' sx={{"& .MuiInputBase-root": {height: 25}}} 
                hiddenlabel="true" 
                variant="outlined" 
                value={findEmail}
                onChange={(e) => {
                  setFindEmail(e.target.value)
                }}
              />
            </div>

            {loading ? (
              <div
                style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}
              >
                <CircularProgress />
              </div>
            ) : 
              (
                <div className={classes.btnDiv}>
                  <Button 
                  variant="outlined"
                  onClick={() => {onFindPw()}}
                  style={{ 
                    background:'#007235', 
                    color:'#fff',
                    fontFamily:[
                      'Noto Sans KR'
                    ],
                    width:'120px',
                    fontSize:'16px',
                  }}              
                >
                  확인
                </Button>
                </div>
              )
            }
          </Box>
        </Modal>

        <Dialog
          open={dialog === '' ? false : true}
          onClose={() => setDialog('')}
        >
          <DialogTitle id="alert-dialog-title">
            {dialog}
          </DialogTitle>
          <DialogActions>
            <Button onClick={() => setDialog('')} autoFocus>
              확인
            </Button>
          </DialogActions>
        </Dialog>
    </div>
  )

}
export default Login;
